import type { LineItemType } from '@forecastify/shared';
import type { MessageKey } from '../../i18n';

/**
 * ┌────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ ONE MAP FOR THE FOUR LINE-ITEM TYPES. There were three.                 │
 * └────────────────────────────────────────────────────────────────────────┘
 *
 * `contract-detail.tsx`, `line-item-detail.tsx` and `history-lines.ts` each kept their own copy of
 * the same three keys. C55's `license` had to be added to all three, and a `Record` keyed by the
 * union is what makes forgetting one a compile error rather than a label reading `undefined` on
 * whichever screen nobody opened.
 */
export const LINE_ITEM_TYPE_KEY: Readonly<Record<LineItemType, MessageKey>> = {
  fixed: 'lineItem.type.fixed',
  time_and_material: 'lineItem.type.timeAndMaterial',
  non_billable: 'lineItem.type.nonBillable',
  /* C55 · *Licenc és díj* — munka nélküli bevétel. */
  license: 'lineItem.type.license',
};
